/**
 * Class that loads settings from JSON file.
 */
import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {ConfigSetting} from '../model/models';
import {HttpClient} from '@angular/common/http';
import {NGXLogger} from "ngx-logger";

const SETTINGS_LOCATION = "assets/appsettings.json";

@Injectable()
export class AppSettingsService {
  private settings = new Array<ConfigSetting>();
  private settingsSubject = new Subject<Array<ConfigSetting>>();

  /**
   * Constructor
   * @param httpClient http client instance.
   * @param logger Logger instanct.
   */
  constructor(private httpClient: HttpClient,
              private logger: NGXLogger) {
  }

  /**
   * Load settings from JSON file
   */
  LoadSettings() {
    this.httpClient.get<Array<ConfigSetting>>(SETTINGS_LOCATION).subscribe((data: Array<ConfigSetting>) => {
      this.settings = data;
      this.logger.debug("AppSettingsService-LoadSettings settings:" + JSON.stringify(this.settings));
      this.setSettings();
    });
  }

  /**
   * Set the settings previously loaded
   */
  setSettings() {
    this.logger.debug("AppSettingsService-setSettings calling next...");
    this.settingsSubject.next(this.settings);
  }

  /**
   * Get the list of settings
   */
  getSettings(): Observable<Array<ConfigSetting>> {
    return this.settingsSubject.asObservable();
  }
}
